// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2XCGM","insightsList":"newBusinessInsightsMenu_insightsList__1jd2D","active":"newBusinessInsightsMenu_active__OdBdc"};